module.exports = __webpack_public_path__ + "img/it.61280cdc.svg";